import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { FormService } from "src/app/core/services/v2/form.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { FormDoc } from "../../../core/models/physician/form-doc";
import { FormDocumentPreviewComponent } from "../form-document-preview/form-document-preview.component";
import { FormFixeddesignPreviewComponent } from "../form-fixeddesign-preview/form-fixeddesign-preview.component";
import { FormTemplateDetailsComponent } from "../form-template-details/form-template-details.component";

@Component({
  selector: "app-form-card-view",
  templateUrl: "./form-card-view.component.html",
  styleUrls: ["./form-card-view.component.scss"],
})
export class FormCardViewComponent implements OnInit {
  @Input() formDoc: FormDoc;
  // @Input() detailsBaseRoute: string = "/physician/forms/details";
  @Output() ReloadListOfFolder = new EventEmitter();

  @Input() isTemplate: boolean;

  // detailsRoute: any;
  constructor(private dialog: MatDialog, private formService: FormService,    private loaderService: WindowLoaderService
, private _router: Router,) {}

  ngOnInit() {
    // this.detailsRoute = [this.detailsBaseRoute, this.formDoc.id];
  }

inactive(frmId: number) {
  //this.errorMessage = "";
  if (frmId && frmId > 0) {
    this.loaderService
      .blockWithLoader(this.formService.deleteForm(frmId))
      .subscribe(
        (templ) => {
          if (templ.resultStatus.isSuccess) {
            console.log("deleted")
            //this.formGroupList.splice(ind, 1);
            this.ReloadListOfFolder.emit(true)
          } else {
            console.error(templ.resultStatus);
          }
        },
        (error) => {
          console.error(error);
          //this.errorMessage = "Folder could not be deleted";
        }
      );
  }
}

  openFormPreview() {
    this._router.navigate([`${this.formService.spaFormDetailsRoute}${this.formDoc.id}`]);

    // if (this.formDoc.formUrl) {
    //   this.dialog.open(FormFixeddesignPreviewComponent, {
    //     data: this.formDoc,
    //     autoFocus: false,
    //     maxHeight: "90vh",
    //     width:"80vw",
    //     hasBackdrop:true
    //   });
    // } else {
    //   if (this.isTemplate) {
    //     this.dialog.open(FormTemplateDetailsComponent, {
    //       panelClass: "custom-dialog-container",
    //       id: "formTemplatePreview",
    //       width: "95%",
    //       height: "95%",
    //       data: {
    //         formId: this.formDoc.id,
    //       },
    //     });
    //   } else {
    //     this.dialog.open(FormDocumentPreviewComponent, {
    //       panelClass: "custom-dialog-container",
    //       id: "formPreview",
    //       width: "95%",
    //       height: "95%",
    //       data: {
    //         formId: this.formDoc.id,
    //       },
    //     });
    //   }
    //}
  }
}
